import { IRoute } from "../shared/model/IRoute";
import { paths } from "./paths";
import Home from "../pages/home/Home";
import Postulate from "../pages/postulate/Postulate";
import HaveProblemForm from "../pages/postulate/modal-document-process/HaveProblemForm";
import ApplicationDetails from "../pages/applicationDetails/ApplicationDetails";
import Resource from "../pages/resources/resource";

const routes: IRoute[] = [
  {
    path: paths.home,
    name: "Home Page",
    exact: true,
    component: Home,
  },
  {
    path: paths.applicationById,
    name: "Application Detail",
    exact: true,
    component: ApplicationDetails,
  },
  {
    path: paths.postulate,
    name: "Postulate Page",
    exact: true,
    component: Postulate,
  },
  {
    path: paths.problem,
    name: "Have a Problem Page",
    exact: true,
    component: HaveProblemForm,
  },
  {
    path: paths.resource,
    name: "Complete Resource",
    exact: true,
    component: Resource,
  },
];
export default routes;
